import { EnrollmentContext } from 'theSource/queries';

export const hasDualContext = (contexts: EnrollmentContext[]) => {
  return contexts.filter((context) => context.status !== 'not_open').length > 1;
};

export const formatDateString = (date?: string) => {
  if (date) {
    const dateArr = date?.split('/');
    return [dateArr[1], dateArr[2], dateArr[0]].join('/');
  }
  return '';
};
